define(['app/controllers/Controller', 'rv!app/views/quickFavourite'], function (
    Controller,
    quickFavouriteTemplate
) {
    function QuickFavouriteController() {
        var Ractive = Controller.ractive;

        function init() {
            ractive = new Ractive({
                el: '.favourites',
                template: quickFavouriteTemplate,
                magic: true,
                data: partyking.common.models.favouriteProducts,
            });
        }

        init();
    }

    return QuickFavouriteController;
});
